import moment from 'moment'
import {
  CardMeta,
  ManagementCard,
  ManagementCardAction,
  ManagementCardList,
} from 'components/ManagementCard'
import { commonStrings, DATE_FORMAT, sendAllMessageStrings } from '../../../constants'
import { DraftMessage } from 'types'
import { TAutoReplyMessageAsset } from 'api'
import { getDraftPreviewLabel } from './draftPreview'

type DraftsCardListProps = {
  drafts: DraftMessage[]
  assets: TAutoReplyMessageAsset[]
  loading: boolean
  onApply: (draftId: string) => void
  onDelete: (draftId: string) => void
  onPreview: (draft: DraftMessage) => void
  className?: string
}

export function DraftsCardList({
  drafts,
  assets,
  loading,
  onApply,
  onDelete,
  onPreview,
  className,
}: DraftsCardListProps) {
  return (
    <ManagementCardList
      loading={loading}
      isEmpty={drafts.length === 0}
      loadingMessage={sendAllMessageStrings.drafts.loading}
      emptyMessage={sendAllMessageStrings.drafts.empty}
      className={className}
    >
      {drafts.map((draft) => (
        <li key={draft.id}>
          <ManagementCard
            onClick={() => onApply(draft.id)}
            ariaLabel={`${sendAllMessageStrings.drafts.preview.defaultName} ${sendAllMessageStrings.drafts.actions.apply}`}
            title={`${sendAllMessageStrings.drafts.preview.defaultName} ${moment(draft.createdAt).format(`${DATE_FORMAT} HH:mm`)}`}
            titleSuffix={`${draft.sections.length}${commonStrings.countSuffix}`}
            actions={
              <>
                <ManagementCardAction onClick={() => onPreview(draft)}>
                  {sendAllMessageStrings.drafts.actions.preview}
                </ManagementCardAction>
                <ManagementCardAction
                  tone="danger"
                  onClick={() => onDelete(draft.id)}
                >
                  {sendAllMessageStrings.drafts.actions.delete}
                </ManagementCardAction>
              </>
            }
          >
            <p className="line-clamp-2 text-xs text-muted">
              {getDraftPreviewLabel(draft, assets)}
            </p>
            <CardMeta
              label={sendAllMessageStrings.drafts.table.createdAt}
              value={moment(draft.createdAt).format(`${DATE_FORMAT} HH:mm`)}
            />
          </ManagementCard>
        </li>
      ))}
    </ManagementCardList>
  )
}
